import { Table } from 'antd'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerText from '../../../components/custom_components/Text'
import { useAuth } from '../../../context/auth-context'
import { useCurrency } from '../../../context/currency-context'
import { useAmountAndCurrency } from '../../../shared/useAmountAndCurrency'
import { useDateTime } from '../../../shared/useDateTime'
import { OneOffPayment } from '../../../types'

interface Props {
  oneOffPayment: OneOffPayment
  showInfo?: boolean
  showSpacer?: boolean
}

export const ConclusionOneOffPayment: FC<Props> = ({ oneOffPayment, showInfo = true, showSpacer = true }) => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const { formatDateMonthYear } = useDateTime(user)
  const { formatCurrency } = useAmountAndCurrency(user.locale)
  const { currency } = useCurrency()

  const columns = [
    {
      key: 'comment',
      title: t('appraisalMeeting.oneOffPayment.title'),
      dataIndex: 'comment',
      render: (comment: string) => <PerText fontWeight="bold">{comment}</PerText>,
    },
    {
      key: 'resultAmount',
      title:
        t('okr.objective.monetary.toBePaid') +
        ' ' +
        t('appraisalMeeting.oneOffPayment.titleIn') +
        ' ' +
        formatDateMonthYear(oneOffPayment.paymentDate, true),
      dataIndex: 'resultAmount',
      className: 'textAlign-right',
      render: (resultAmount: number) => <PerText color={'primary'}>{formatCurrency(resultAmount, currency, true)}</PerText>,
    },
  ]

  return (
    <>
      {!!oneOffPayment && (
        <div data-e2e-oneoff-conclusion>
          {!!showSpacer && (
            <PerFlexRow justify="space-between" align="middle" mb="s">
              <PerFlexRow align="middle">&nbsp;</PerFlexRow>
            </PerFlexRow>
          )}
          <Table dataSource={[{ ...oneOffPayment, key: 0 }]} columns={columns} pagination={false} />
          <PerFlexRow align="middle">&nbsp;</PerFlexRow>
          {!!showInfo && (
            <PerText appearance="info" mb="l">
              {t('appraisalMeeting.stepConclusion.oneOffPaymentInfo')}
            </PerText>
          )}
        </div>
      )}
    </>
  )
}
